module.exports = __webpack_public_path__ + "static/media/microsoft_exchange.03522870.ico";